import React from 'react'
import get from 'lodash/get'
import c from 'classnames'
import { connect } from 'react-redux'

import { getEntity } from 'selectors/entitySelectors'
import { money } from 'utils'

import './Meta.scss'

export function VehicleMeta({ vehicle, className, showVin, showPrice }) {
  let driveWheels = get(vehicle, 'vinDetails.description.driveWheels', ''),
    type = get(vehicle, 'type', '') || '',
    price = get(vehicle, 'quote.price', 0)

  return (
    <span className={c('vehicle-meta', className)}>
      <span className={c('vehicle-type', type.toLowerCase())}>{type}</span>
      {vehicle.stockNumber ? (
        <span className="stock-number">
          <span>Stock#</span> {vehicle.stockNumber}
        </span>
      ) : (
        <span className="stock-number stock-number-e">On the Way</span>
      )}
      {showVin && driveWheels && (
        <span className="drive-wheels">{driveWheels}</span>
      )}
      {showVin && (
        <span className="vin-number">
          <span>VIN</span> {vehicle.vin}
        </span>
      )}
      {showPrice && price && price > 0 && (
        <span className="price-number">{money(price)}</span>
      )}
    </span>
  )
}

function mapStateToProps(state, op) {
  return {
    ...op,
    vehicle: getEntity(state, op.id),
  }
}

export default connect(mapStateToProps)(VehicleMeta)
